function type_is_selected(type) {
  const emplacement = document.querySelector(
    `.creation_selection_ear img[data-type="${type}"]`
  );
  return emplacement !== null;
}

function reset_type(type) {
  document
    .querySelectorAll(`.creation_selection_ear img[data-type="${type}"]`)
    .forEach(function (emplacement) {
      emplacement.remove();
    });

  document
    .querySelectorAll(
      `.jewelry_list .selected.jewelry_variant[data-type="${type}"]`
    )
    .forEach(function (jewelry) {
      jewelry.classList.remove("selected");
    });

  document
    .querySelectorAll(`.creation_selection_list div[data-type="${type}"]`)
    .forEach(function (selection) {
      selection.remove();
    });
}

function update_price() {
  const selected = document.querySelectorAll(
    ".creation_selection_list .creation_selection_item"
  );
  let price = 0;

  selected.forEach(function (jewelry) {
    price +=
      parseInt(jewelry.dataset.price) * parseInt(jewelry.dataset.quantity);
  });

  document.querySelectorAll(".creation_price").forEach(function (button) {
    button.innerHTML = price + "€";
  });

  document.querySelectorAll(".creation_total_price").forEach(function (button) {
    button.innerHTML = "€" + price + " EUR";
  });
  document.querySelector(".creation_total_price").dataset.price = price;

  document.querySelectorAll(".creation_button").forEach(function (button) {
    if (price === 0) {
      button.classList.add("disabled");
    } else {
      button.classList.remove("disabled");
    }
  });

  if (selected.length === 0) {
    document
      .querySelector(".creation_selection_empty")
      .classList.remove("hidden");
  } else {
    document.querySelector(".creation_selection_empty").classList.add("hidden");
  }
}

function create_selection(uid, type, title, price, url, image, type_title) {
  const selection = document.querySelector(".creation_selection_list");

  const item = document.createElement("div");
  item.classList.add("creation_selection_item");
  item.setAttribute("data-uid", uid);
  item.setAttribute("data-type", type);
  item.setAttribute("data-price", price);
  item.setAttribute("data-quantity", "1");

  const product_wrapper = document.createElement("div");
  product_wrapper.classList.add("creation_selection_product_wrapper");

  const image_wrapper = document.createElement("div");
  image_wrapper.classList.add("creation_selection_image_wrapper");

  const image_item = document.createElement("img");
  image_item.classList.add("creation_selection_image");
  image_item.setAttribute("src", image);
  image_wrapper.appendChild(image_item);

  product_wrapper.appendChild(image_wrapper);

  const information = document.createElement("div");
  information.classList.add("creation_selection_information");

  const title_item = document.createElement("a");
  title_item.classList.add("creation_selection_title");
  title_item.classList.add("font-heading");
  title_item.setAttribute("href", url);
  title_item.innerHTML = title;
  information.appendChild(title_item);

  const price_item = document.createElement("div");
  price_item.classList.add("creation_selection_price");
  price_item.innerHTML = price + "€";
  information.appendChild(price_item);

  const type_title_item = document.createElement("div");
  type_title_item.classList.add("creation_selection_type_title");
  type_title_item.innerHTML = type_title;
  information.appendChild(type_title_item);

  product_wrapper.appendChild(information);
  item.appendChild(product_wrapper);

  control_wrapper = document.createElement("div");
  control_wrapper.classList.add("creation_selection_control_wrapper");

  const quantity_item = document.createElement("div");
  quantity_item.classList.add("creation_selection_quantity");
  quantity_item.classList.add("quantity-selector");

  const quantity_minus = document.createElement("button");
  quantity_minus.classList.add("quantity__minus");
  quantity_minus.setAttribute("type", "button");
  quantity_minus.innerHTML = "—";

  const quantity_input = document.createElement("input");
  quantity_input.classList.add("quantity__input");
  quantity_input.setAttribute("type", "number");
  quantity_input.setAttribute("value", "1");
  quantity_input.setAttribute("min", "1");
  quantity_input.setAttribute("max", "99");
  quantity_input.setAttribute("aria-label", "quantity");
  quantity_input.setAttribute("autocomplete", "off");
  quantity_input.setAttribute("name", "quantity");
  quantity_input.setAttribute("pattern", "[0-9]*");

  const quantity_plus = document.createElement("button");
  quantity_plus.classList.add("quantity__plus");
  quantity_plus.setAttribute("type", "button");
  quantity_plus.innerHTML = "+";

  quantity_input.addEventListener("change", change_quantity);

  quantity_minus.addEventListener("click", (e) => {
    const input = e.currentTarget.parentNode.querySelector("input");
    input.value = parseInt(input.value) - 1;
    change_quantity({ currentTarget: input });
  });

  quantity_plus.addEventListener("click", (e) => {
    const input = e.currentTarget.parentNode.querySelector("input");
    input.value = parseInt(input.value) + 1;
    change_quantity({ currentTarget: input });
  });

  quantity_item.appendChild(quantity_minus);
  quantity_item.appendChild(quantity_input);
  quantity_item.appendChild(quantity_plus);
  control_wrapper.appendChild(quantity_item);

  const remove = document.createElement("div");
  remove.classList.add("creation_selection_remove");
  remove.addEventListener("click", remove_selection);

  const remove_icon = document.querySelector(".icon-cancel").cloneNode(true);
  remove.appendChild(remove_icon);

  control_wrapper.appendChild(remove);
  item.appendChild(control_wrapper);

  selection.appendChild(item);
}

function add_item(e) {
  const target = e.currentTarget.parentNode;

  const background = document.querySelector(".creation_selection_ear");

  const uid = target.dataset.uid;
  const type = target.dataset.type;
  const mask = target.dataset.mask;
  const price = target.dataset.price;
  const title = target.dataset.title;
  const image = target.dataset.image;
  const url = target.dataset.url;
  const type_title = target
    .closest(".jewelry_type_list")
    .querySelector(".title-type").innerHTML;

  // Vérifier si le bijou est déjà sélectionné
  if (target.classList.contains("selected")) {
    reset_type(type);
  } else {
    // Vérifier si l'emplacement est déjà pris
    if (type_is_selected(type)) {
      reset_type(type);
    }

    // Ajouter bijou
    const jewelry = document.createElement("img");
    jewelry.setAttribute("src", mask);
    jewelry.setAttribute("data-uid", uid);
    jewelry.setAttribute("data-type", type);
    background.appendChild(jewelry);

    // Marquer bijou comme sélectionné
    target.classList.add("selected");

    // Ajouter à la liste de sélection
    create_selection(uid, type, title, price, url, image, type_title);
  }

  update_price();
}

function remove_selection(e) {
  const type = e.currentTarget.closest(".creation_selection_item").dataset.type;
  reset_type(type);

  update_price();
}

function change_quantity(e) {
  const item = e.currentTarget.closest(".creation_selection_item");

  const value = parseInt(e.currentTarget.value);

  if (value < 1) {
    e.currentTarget.value = 1;
  } else if (value > 99) {
    e.currentTarget.value = 99;
  }

  item.setAttribute("data-quantity", e.currentTarget.value);

  update_price();
}

function add_to_cart(e) {
  if (e.currentTarget.classList.contains("disabled")) {
    return;
  }

  const items = [];

  document
    .querySelectorAll(".creation_selection_list > div")
    .forEach(function (item) {
      items.push({
        id: item.dataset.uid.split("-")[0],
        quantity: parseInt(item.dataset.quantity),
      });
    });

  if (items.length === 0) {
    alert("Vous devez sélectionner au moins un bijou.");
    return;
  }

  const first = items[0];

  if(items.length == 1) {
    document.dispatchEvent(
      new CustomEvent("theme:cart:add", {
        bubbles: true,
        detail: {
          data: {
            id: first.id,
            quantity: first.quantity,
          },
        },
    }));
  }
  else {
    fetch("/cart/add.js", {
      method: "POST",
      body: JSON.stringify({ items: items.splice(1) }),
      headers: {
        "Content-Type": "application/json",
      },
    }).then(function (response) {
      if (response.status === 200) {
        document.dispatchEvent(
          new CustomEvent("theme:cart:add", {
            bubbles: true,
            detail: {
              data: {
                id: first.id,
                quantity: first.quantity,
              },
            },
        }));
      }
      
      if (response.status === 422) {
        response.json().then(function (data) {
          alert(data.description);
        });
      }
    });
  }
}

function onglets() {
  const tab_titles = document.querySelectorAll(".tab_title");

  function select_tab(button) {
    const current = button.closest(".jewelry_variant");

    const type = current.dataset.type;
    const product = current.dataset.title;
    const couleur = button.dataset.tab;

    const target = document.querySelector(
      `.jewelry_variant.${couleur}[data-type="${type}"][data-title="${product}"]`
    );

    if (target) {
      current.classList.remove("active");
      target.classList.add("active");
    }
  }

  // Ajouter un événement click à chaque onglet
  tab_titles.forEach((tab_title) => {
    tab_title.addEventListener("click", () => {
      select_tab(tab_title);
    });
  });

  // Sélectionner le premier onglet
  document.querySelectorAll(".jewelry_variant").forEach(function (variant) {
    const previous = variant.previousElementSibling;
    const next = variant.nextElementSibling;

    if (
      previous === null ||
      !previous.classList.contains("jewelry_variant") ||
      previous.dataset.type !== variant.dataset.type ||
      previous.dataset.title !== variant.dataset.title
    ) {
      variant.classList.add("active");

      if (
        next === null ||
        !next.classList.contains("jewelry_variant") ||
        next.dataset.type !== variant.dataset.type ||
        next.dataset.title !== variant.dataset.title
      ) {
        variant.querySelector(".creation_color").classList.add("invisible");
      }
    }
  });
}

function toggle_ear_map() {
  const map = document.querySelector(".ear_description");
  map.classList.toggle("hidden");
}

let last_type = null;
function select_type(e) {
  const type = e.currentTarget.dataset.type;
  last_type = type;

  const selected =
    document.querySelector(
      `.selected.jewelry_type_list[data-type="${type}"]`
    ) !== null;

  document
    .querySelectorAll(".jewelry_type_list.selected")
    .forEach(function (list) {
      list.classList.remove("selected");
    });

  document
    .querySelectorAll(".ear_description svg g.selected")
    .forEach(function (list) {
      list.classList.remove("selected");
    });

  if (!selected) {
    document
      .querySelectorAll(`.jewelry_type_list[data-type="${type}"]`)
      .forEach(function (list) {
        list.classList.add("selected");
      });

    document
      .querySelectorAll(".creation_header_type")
      .forEach(function (header) {
        const title = document.querySelector(
          ".jewelry_type_list.selected .title-type"
        );

        if (title === null) {
          header.innerHTML = type;
        } else {
          header.innerHTML = title.innerHTML;
        }
      });

    e.currentTarget.classList.add("selected");

    document.querySelector(".creation_content").dataset.step = "shopping";
  } else {
    document.querySelector(".creation_content").dataset.step = "introduction";
  }
}

function view_summary(e) {
  if (e.currentTarget.classList.contains("disabled")) {
    return;
  }

  document
    .querySelectorAll(".ear_description svg g.selected")
    .forEach(function (list) {
      list.classList.remove("selected");
    });

  document
    .querySelectorAll(".selected.jewelry_type_list")
    .forEach(function (list) {
      list.classList.remove("selected");
    });

  document.querySelector(".creation_content").dataset.step = "summary";
}

function close_tab() {
  creationTotalPrice = document.querySelector(".creation_total_price").dataset
    .price;

  document
    .querySelectorAll(".jewelry_type_list.selected")
    .forEach(function (list) {
      list.classList.remove("selected");
    });
  document
    .querySelectorAll(".ear_description svg g.selected")
    .forEach(function (list) {
      list.classList.remove("selected");
    });

  if (creationTotalPrice === "0")
    document.querySelector(".creation_content").dataset.step = "introduction";
  else document.querySelector(".creation_content").dataset.step = "summary";
}

function back_to_last(e) {
  select_type({
    currentTarget: document.querySelector(
      `.ear_description svg g[data-type="${last_type}"]`
    ),
  });
}

(function () {
  if (document.querySelector("#ma-creation") === null) {
    return;
  }

  // Appel des fonctions
  onglets();

  document
    .querySelectorAll(
      ".jewelry_list .jewelry_variant:not(.out-of-stock) .jewelry_information"
    )
    .forEach(function (jewelry) {
      jewelry.addEventListener("click", add_item);
    });

  document
    .querySelector(".creation_add_to_cart")
    .addEventListener("click", add_to_cart);

  document
    .querySelector(".hide_description")
    .addEventListener("click", toggle_ear_map);

  document.querySelectorAll(".ear_description svg g").forEach(function (group) {
    group.addEventListener("click", select_type);
  });

  document
    .querySelector(".creation_view_selection")
    .addEventListener("click", view_summary);

  document
    .querySelector(".creation_closer")
    .addEventListener("click", close_tab);

  document.querySelectorAll(".creation_back").forEach(function (button) {
    button.addEventListener("click", back_to_last);
  });
})();
